import { SIDEBAR_ANIMATION_STEPS } from '../sidebar/animations/types';

export default {
  showHeaderProfile: SIDEBAR_ANIMATION_STEPS.DEFAULT,
  showSearch: false,
  showRecipesBoxLoginRegisterNotification: false
}
